var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorRedDownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4148 0.972013C19.2291 0.78616 19.0086 0.638726 18.7658 0.538136C18.5231 0.437547 18.2629 0.385773 18.0002 0.385773C17.7374 0.385773 17.4772 0.437547 17.2345 0.538136C16.9918 0.638726 16.7712 0.78616 16.5855 0.972013L10.4708 7.08535C10.3458 7.21033 10.1763 7.28054 9.9995 7.28054C9.82273 7.28054 9.65319 7.21033 9.52817 7.08535L3.41484 0.972013C3.03982 0.59682 2.53112 0.385968 2.00064 0.385843C1.47016 0.385718 0.961362 0.596329 0.586169 0.971346C0.210976 1.34636 0.000125084 1.85506 5.56348e-08 2.38554C-0.000124973 2.91602 0.210487 3.42482 0.585503 3.80002L6.70017 9.91469C7.13351 10.3481 7.64799 10.6919 8.2142 10.9264C8.78042 11.161 9.38729 11.2817 10.0002 11.2817C10.613 11.2817 11.2199 11.161 11.7861 10.9264C12.3524 10.6919 12.8668 10.3481 13.3002 9.91469L19.4148 3.80002C19.7898 3.42496 20.0004 2.91634 20.0004 2.38601C20.0004 1.85569 19.7898 1.34707 19.4148 0.972013Z",
    fill: "#ED3E3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorRedDownIcon);
export default __webpack_public_path__ + "static/media/vectorRedDown_icon.ddfc63e0fc5d30d0807a27d3629cb30a.svg";
export { ForwardRef as ReactComponent };